import { db, rdb } from "@/firebase/config";

export const selectFrom = (type, collection, chapterID, contents) => {
    const requestContents = contents && chapterID ? '/contents' : '';
    const requestChapter = chapterID ? `/${chapterID + (requestContents)}` : '';
    const params = collection + requestChapter;
    const selectResponse =  db[type](params) 
    return selectResponse;
};
export const addChapter = async (chapter) => {
    try {
        let result = await selectFrom("collection", "chapters")
            .add(chapter);
        return result;
    } catch(exception) {
        return null;
    }
};

export const chapterCollectionRef = selectFrom("collection", "chapters");
export const chapterOrderRef = rdb.ref("chapterOrder");

export const getChapterByID = id => selectFrom("doc", "chapters", id)

export const updateChapter = async (chapterID, newFieldValue) => {
    try {
        getChapterByID(chapterID).update(newFieldValue);
        const fieldUpdated = Object.keys(newFieldValue)[0]
        return fieldUpdated
    } catch (error) {
        return false;
    }
};

export const deleteChapter = async (chapterID) => {
    try {
        getChapterByID(chapterID).delete()
        return true;
    } catch(exception) {
        return false;
    }
}